<template>
  <div>
    <div class="text-xs-center mb-2" v-if="showTop">
      <v-progress-linear v-if="loading" :indeterminate="true" :height="2"></v-progress-linear>
      <v-pagination
        v-else
        @input="changepage"
        v-model="page"
        :length="pagelength"
        :total-visible="7"
      ></v-pagination>
    </div>

    <slot></slot>

    <div class="text-xs-center mt-2" v-if="showBottom">
      <v-progress-linear v-if="loading" :indeterminate="true" :height="2"></v-progress-linear>
      <v-pagination
        v-else
        @input="changepage"
        v-model="page"
        :length="pagelength"
        :total-visible="7"
      ></v-pagination>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      default: 1
    },
    total: {
      default: 1
    },
    limit: {
      default: 10
    },
    loading: {
      default: false
    },
    showTop: {
      default: true
    },
    showBottom: {
      default: true
    }
  },
  data() {
    return {
      pagetmp: '',
      offset: 1,
      page: this.value
    }
  },
  computed: {
    pagelength() {
      if (this.total) {
        var total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    }
  },
  methods: {
    changepage(val) {
      var vm = this

      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.page * vm.limit - vm.limit
        if (vm.page != 1) {
          vm.offset + 1
        }
        this.$emit('onChange', { limit: vm.limit, offset: vm.offset })
      }
      this.$emit('input', vm.page)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/Pagination2.vue